module.exports = {
	MORE_THAN_ONE_RECORD : 1,
	NO_LOADING_RECORDS: 2,
	UNKNOWN_LOCATION: 3,
	STARTING_A_CYCLE_WITHOUT_ENDING_PREVIOUS: 4,
	NO_OPEN_RECORDS_FOUND: 5,
	NO_PREVIOUS_RECORDS_FOR_BATTERY: 6,
	FORKLIFT_HAS_OPEN_CYCLE: 7,
}